export const StateAdminCSVHeader = {
  "S#": "S#",
  "First Name": "First Name",
  "Last Name": "Last Name",
  "User ID": "User ID",
  "Phone number": "Phone number",
  "Date of birth": "Date of birth",
  State: "State",
  Districts: "Districts",
  errorMessage: "errorMessage",
};

export const AshaCSVHeader = {
  "S#": "S#",
  "First Name": "First Name",
  "Last Name": "Last Name",
  "ASHA ID": "ASHA ID",
  "Phone number": "Phone number",
  "Date of birth": "Date of birth",
  /*  "Marital status": "Marital status",
    "Husband Name": "Husband Name", */
  "Village/Slum": "Village/Slum",
  "Sub Center": "Sub Center",
  "UPHC/PHC": "UPHC/PHC",
  "District/Block": "District/Block",
  State: "State",
  "Pin code": "Pin code",
  errorMessage: "errorMessage",
};

export const StateAbbreviationList = [
  "AP",
  "AS",
  "BH",
  "GJ",
  "KA",
  "MP",
  "RJ",
  "UP",
  "UK",
];
